export const getCartTotal = (cart) => {
  return cart.length !== 0
    ? Math.round(
        cart
          .map((eachItem) => eachItem.quantity * eachItem.product.price)
          .reduce((total, currentValue) => total + currentValue) * 100
      ) / 100
    : 0;
};
